import config from "../../../../common-sk-doc/src/config";

export enum BookExtraResourceType {
  All,
  Student,
  Teacher,
}
export enum BookExtraResourceStatus {
  Hide,
  Show,
}

export const bannerHDOT = [
  {
    code: 'english',
    image: config.ASSETS_PATH + '/images/book/HDOT_TiengAnh.webp',
  },
  {
    code: 'math',
    image: config.ASSETS_PATH + '/images/book/HDOT_Toan.webp',
  },
  {
    code: 'literature',
    image: config.ASSETS_PATH + '/images/book/HDOT_NguVan.webp',
  },
  {
    code: 'geography',
    image: config.ASSETS_PATH + '/images/book/HDOT_DiaLi.webp',
  },
  {
    code: 'chemistry',
    image: config.ASSETS_PATH + '/images/book/HDOT_HoaHoc.webp',
  },
  {
    code: 'biology',
    image: config.ASSETS_PATH + '/images/book/HDOT_SinhHoc.webp',
  },
  {
    code: 'physics',
    image: config.ASSETS_PATH + '/images/book/HDOT_VatLi.webp',
  },
  {
    code: 'civic-education',
    image: config.ASSETS_PATH + '/images/book/HDOT_GDCD.webp',
  },
  {
    code: 'history',
    image: config.ASSETS_PATH + '/images/book/HDOT_LichSu.webp',
  },
  {
    code: 'natural-social',
    image: config.ASSETS_PATH + '/images/book/HDOT_TN_XH.webp',
  },
  {
    code: 'natural-sciences',
    image: config.ASSETS_PATH + '/images/book/HDOT_KH_TN.webp',
  },
  {
    code: 'social-studies',
    image: config.ASSETS_PATH + '/images/book/HDOT_KH_XH.webp',
  },
];

export enum BookType {
  Sachthamkhao = 0,
  SHSTiengAnh = 1,
  SBTTiengAnh = 2,
  LuyenthiTHPT = 3,
  HDOT = 4,
  MyLittleFun = 5,
  Chantroisangtao = 6,
  Canhdieu = 7,
  SGKTiengAnh = 8,
  Ketnoitrithucvoicuocsong = 9,
  Hoclieuthongminh = 10,
  Khac = 100,
}

export enum ChapterType {
  Default,
  Parent,
  Checkpoint,
  Review,
}

export enum ExtraResourceGroup {
  Default,
  Games,
  Quizzes,
  Workbook,
  VocabularyBank,
  GrammarBank,
  Documentaries,
  Video,
  Wordlist,
}

export const extraResourceGroupOptions = [
  {
    label: 'Extra Resources',
    value: ExtraResourceGroup.Default,
    icon: '/icons/extra/extra-resource.svg',
  },
  {
    label: 'Games',
    value: ExtraResourceGroup.Games,
    icon: '/icons/extra/game.svg',
  },
  {
    label: 'Quizzes',
    value: ExtraResourceGroup.Quizzes,
    icon: '/icons/extra/quiz.svg',
  },
  {
    label: 'Workbook',
    value: ExtraResourceGroup.Workbook,
    icon: '/icons/extra/work-book.svg',
  },
  {
    label: 'Vocabulary Bank',
    value: ExtraResourceGroup.VocabularyBank,
    icon: '/icons/extra/vocabulary-bank.svg',
  },
  {
    label: 'Grammar Bank',
    value: ExtraResourceGroup.GrammarBank,
    icon: '/icons/extra/grammar-bank.svg',
  },
  {
    label: 'Documentaries',
    value: ExtraResourceGroup.Documentaries,
    icon: '/icons/extra/documentary.svg',
  },
  {
    label: 'Video',
    value: ExtraResourceGroup.Video,
    icon: '/icons/extra/video.svg',
  },
  {
    label: 'Wordlist',
    value: ExtraResourceGroup.Wordlist,
    icon: '/icons/extra/wordlist.svg',
  },
];

export const getChapterIndex = (
  chapters,
  n,
  hideIndexReview: boolean = false,
): number => {
  let index = n + 1;
  for (let i = 0; i <= n; i++) {
    index -=
      chapters[i]?.type === ChapterType.Parent ||
      (hideIndexReview && chapters[i]?.type === ChapterType.Review)
        ? 1
        : 0;
  }
  return index;
};

export const checkChapterHasGame = (chapter) => {
  return (
    chapter.lessons
      .map((l) => l.sections)
      .reduce((a, b) => a.concat(b), [])
      .map((s) => s.sectionGames)
      .reduce((a, b) => a.concat(b), []).length > 0
  );
};
